import { NgModule } from '@angular/core';
import { MenuItemComponent } from './menu-item/menu-item.component';
import { MenubarComponent } from './menubar/menubar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CardModule } from 'primeng/card';
import { MatInputModule } from '@angular/material/input'; // Import MatInputModule
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatListModule } from '@angular/material/list';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { TextFieldComponent } from './text-field/text-field.component';
import { RouterModule } from '@angular/router';
import { TableCommonComponent } from './table-common/table-common.component';
import { MatRow, MatTableModule } from '@angular/material/table';
import { MatDialogContent, MatDialogModule } from '@angular/material/dialog';
import {
  MatPaginatorIntl,
  MatPaginatorModule,
} from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { SearchComponent } from './search/search.component';
import { MatButtonModule } from '@angular/material/button';
import { AddInputComponent } from './add-input/add-input.component';
import { InputCommonComponent } from './input-common/input-common.component';
import { DropdownCommonComponent } from './dropdown-common/dropdown-common.component';
import { ConfirmDeleteDialogComponent } from './dialog/confirm-delete-dialog/confirm-delete-dialog.component';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';

@NgModule({
  declarations: [
    MenuItemComponent,
    MenubarComponent,
    SidebarComponent,
    TextFieldComponent,
    TableCommonComponent,
    SearchComponent,
    AddInputComponent,
    InputCommonComponent,
    DropdownCommonComponent,
    ConfirmDeleteDialogComponent,
    LoadingSpinnerComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CardModule,
    MatInputModule,
    MatFormFieldModule,
    MatRadioModule,
    MatCheckboxModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatListModule,
    MatIcon,
    RouterModule,
    MatRow,
    MatDialogContent,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatButtonModule,
    MatIconModule,
    FormsModule,
    MatDialogModule,
  ],
  providers: [{ provide: MatPaginatorIntl, useClass: TableCommonComponent }],
  exports: [
    MenuItemComponent,
    MenubarComponent,
    SidebarComponent,
    TextFieldComponent,
    TableCommonComponent,
    SearchComponent,
    AddInputComponent,
    InputCommonComponent,
    DropdownCommonComponent,
    LoadingSpinnerComponent,
  ],
})
export class CommonAppModule {}
